import { useMutation } from "react-query";
import { brazeLogCustomEventAddToFavorites } from "../../helpers/brazeHelper";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";
import { ItemFields } from "../../models/Menu.model";
import { orderMicroService } from "../../services";

const addFavorite = async (item, isItMobile) => {
  //TODO: Replace customer id with an actual current login customer id
  const payload = {
    image: item.image,
    customer_id: item.customer_id,
    brink_id: item.brink_id || item.full_brink_item_id || 5,
    item_id: item.item_id || item.id,
    display_price: item.display_price || item.price,
    item_description: item.description || "Description",
    modifiers: item.modifiers || [],
  }
  const response = await orderMicroService.addToFavorites(payload)
  brazeLogCustomEventAddToFavorites(item, isItMobile);
  return response.data.data;
};

export default function useAddFavorites() {
  const isItMobile = useCheckMobileScreen();
  return useMutation((item: ItemFields) => addFavorite(item, isItMobile));
}
